import TWEEN from 'tween.js';

function getCoordinatesForPercent(percent) {
  const x = Math.cos(2 * Math.PI * percent);
  const y = Math.sin(2 * Math.PI * percent);
  return [x, y];
}

function animateNumber(from, to, setFunction, easing = TWEEN.Easing.Quadratic.Out) {
  let animationFrame = null;

  const animate = time => {
    TWEEN.update(time);
    animationFrame = window.requestAnimationFrame(animate);
  };

  new TWEEN.Tween({ tweeningNumber: from })
    .easing(easing)
    .to({ tweeningNumber: to })
    .onUpdate(function onSvgReachTweenUpdate() {
      setFunction(Number(this.tweeningNumber.toFixed(0)));
    })
    .onComplete(() => window.cancelAnimationFrame(animationFrame))
    .start();

  animationFrame = window.requestAnimationFrame(animate);
}

export default {
  props: {
    guaranteedReach: Number,
    notReached: Number,
  },
  data() {
    return {
      internalGuaranteed: 1,
      internalNotReached: 1,
    };
  },
  computed: {
    percentGuaranteed() {
      const totalReach = this.internalGuaranteed + this.internalNotReached;
      const percent = this.internalGuaranteed / (totalReach || 1); // no div by zero
      if (percent === 1) {
        return 0.99999; // IE11 / Edge fix
      }
      return percent;
    },
    guaranteedSlice() {
      const [startX, startY] = getCoordinatesForPercent(0);
      const [endX, endY] = getCoordinatesForPercent(this.percentGuaranteed);
      const largeArcFlag = this.percentGuaranteed > 0.5 ? 1 : 0;
      return [
        `M ${startX} ${startY}`,
        `A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY}`,
        'L 0 0',
      ].join(' ');
    },
    notReachedSlice() {
      const [startX, startY] = getCoordinatesForPercent(this.percentGuaranteed);
      const [endX, endY] = getCoordinatesForPercent(100);
      const largeArcFlag = (1 - this.percentGuaranteed) > 0.5 ? 1 : 0;
      return [
        `M ${startX} ${startY}`,
        `A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY}`,
        'L 0 0',
      ].join(' ');
    },
  },
  watch: {
    guaranteedReach(after, before) {
      animateNumber(before, after, value => this.internalGuaranteed = value);
    },
    notReached(after, before) {
      animateNumber(before, after, value => this.internalNotReached = value);
    },
  },
  mounted() {
    this.internalGuaranteed = this.guaranteedReach;
    this.internalNotReached = this.notReached;
  },
};



// WEBPACK FOOTER //
// ./src/components/svg-reach-chart/SvgReachChart.js